export default  class  InventoryReportDetailInput{
    warehouseCode :string;
    type:string;
    assetTypeCode:string;
    conditionTypeCode:string;
    productId:number;
    assetTypeName:string;
    conditionTypeName:string;
    sku:string;
    productName:string;
}